<template>
  <div style="height: 400px; max-width: 100%; width: 99%;">
    <Doughnut :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement } from 'chart.js'
import { Doughnut } from 'vue-chartjs'

ChartJS.register(Title, Tooltip, Legend, ArcElement)

export default {
  name: 'DoughnutChart',
  components: { Doughnut },
  props: {
    labels: { type: Array, required: true }, // ej: ['Efectivo', 'Débito', 'Crédito']
    data: { type: Array, required: true }, // ej: [300, 200, 100]
    colors: { type: Array, default: () => ['#222222', '#FB925A', '#FF5700'] }
  },
  computed: {
    chartData () {
      return {
        labels: this.labels,
        datasets: [
          {
            data: this.data,
            backgroundColor: this.colors
          }
        ]
      }
    },
    chartOptions () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: 'top' },
          title: { display: false }
        }
      }
    }
  }
}
</script>
